import React from 'react';
import { Box, Typography } from '@mui/material';

/** Cabeçalho padrão das páginas internas do ARCA (modelos, config). */
export default function ArcaPageShell({ title, subtitle, children, maxWidth = 960 }) {
  return (
    <Box sx={{ maxWidth, mx: 'auto', width: '100%' }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" fontWeight={800} color="primary.main" gutterBottom>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body1" color="text.secondary">
            {subtitle}
          </Typography>
        )}
      </Box>
      {children}
    </Box>
  );
}
